<style src="./Dropdown.scss" lang="scss" scoped></style>
<template lang="html">
  <fieldset class="component"
    :class="{'dropdown__focused': classFocus}"
    @click="getMeFocus()"
    tabindex="0"
    @focus="setFocus"
    @blur="lostFocus"
    @keyup.enter="enterContainer"
    @keydown.down="setPosition('down')"
    @keydown.up="setPosition('up')">

    <label class="label" :class="{'dropdown--element-expanded': listedItems.length > 0}">
      <span class="caption">{{ label }}</span>
      <div class="component-container">
        <span class="component-input">{{ selectedValue }}</span>
        <div class="dropdown--arrow-container">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 284.929 284.929" style="enable-background:new 0 0 284.929 284.929;"
            xml:space="preserve"
            class="dropdown--arrow-icon">
            <g>
              <path d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441
              L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082
              c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647
              c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z"/>
            </g>
          </svg>
        </div>
      </div>

      <!-- <span class="error-message" v-show="!isValid">{{ messageError[0] }}</span> -->
    </label>

    <div class="dropdown--list-container" v-show="listedItems.length > 0" >
      <div v-shortkey="['esc']" @shortkey="lostFocus" v-if="listedItems.length > 0"></div>
      <ul class="dropdown--list-result" ref="_listObj">
        <li
          v-for="item,idx in listedItems"
          :class="{'dropdown--selected-item': focusedItem === idx, ['dropdown-item' + idx]: true}"
          @mouseover="setListItemFocus(idx)">
          {{ item.text }}
        </li>
      </ul>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    label: {
      default: ''
    },
    value: {
      default: null
    },
    placeholder: {
      default: ''
    },
    listData: {
      default: () => ([])
    }
  },
  data () {
    return {
      classFocus: false,
      txtValue: '',
      selectedValue: null,
      listedItems: [],
      selectedItem: {},
      focusedItem: null
    }
  },
  watch: {
    'value': {
      handler (pValue, pOldValue) {
        this.refreshValues()
      },
      immediate: true
    },
    'txtValue' (pValue, pOldValue) {
      this.$emit('input', pValue)
    },
    listData (pValue) {
      this.refreshValues()
    }
  },
  methods: {
    refreshValues () {
      this.txtValue = this.value
      if (this.value) {
        let indexList = null
        this.listData.map((pItem, pIdx) => { if (pItem.value === this.value) indexList = pIdx })
        if (indexList !== null) {
          this.selectedItem = this.listData[indexList]
          this.selectedValue = this.listData[indexList].text
        }
      }
    },
    setListItemFocus (pIdx) {
      if (pIdx !== this.focusedItem) {
        this.focusedItem = pIdx
        return true
      } else {
        return false
      }
    },
    setPosition (pDirection) {
      if (this.listedItems.length < 1) this.enterContainer()
      let selectingIdx = this.focusedItem
      switch (pDirection) {
        case 'down':
          selectingIdx = selectingIdx + 1 > this.listData.length - 1 ? selectingIdx : ++selectingIdx
          break
        case 'up':
          selectingIdx = selectingIdx - 1 < 0 ? 0 : --selectingIdx
          break
      }
      this.focusedItem = selectingIdx
      this.setScrollPosition()
    },
    setScrollPosition () {
      if (this.listData && this.listData.length > 0) {
        let item = document.querySelector(`.dropdown-item${this.focusedItem}`)
        let objMe = this.$refs._listObj
        objMe.scrollTop = item ? item.offsetTop : 0
      }
    },
    setFocus () {
      this.classFocus = true
      // this.toggleDropdown(false)
    },
    lostFocus (ev) {
      ev.stopPropagation()
      this.classFocus = false
      this.listedItems = []
    },
    getMeFocus () {
      this.enterContainer()
    },
    enterContainer () {
      if (this.listedItems.length > 0) {
        // Select item'
        if (this.focusedItem !== null) {
          this.selectedItem = this.listedItems[this.focusedItem]
          this.selectedValue = this.listedItems[this.focusedItem].text
          this.$emit('input', this.listedItems[this.focusedItem])
          this.$emit('selected', this.listedItems[this.focusedItem])
        }
        // this.lostFocus()
        this.listedItems = []
      } else {
        // Open list
        this.classFocus = true
        this.listedItems = this.listData
        this.setScrollPosition()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/dropdown/Dropdown.vue